import { CollectionFormFields, ResourceType, RawCollection } from '../types';
import { getOptimisticId } from './utils';
import { OptimisticUpdater } from './types';

interface OptimisticallyCreateCollectionProps {
    collection: CollectionFormFields;
    resourceType?: ResourceType;
    resourceId?: string;
}

/**
 * Optimistically creates a collection.
 * Returns a rollback function to be used in case of an error.
 */
export const optimisticallyCreateCollection: OptimisticUpdater<OptimisticallyCreateCollectionProps> = (
    queryClient,
    { collection, resourceType, resourceId }
) => {
    const optimisticCollectionId = getOptimisticId();

    queryClient?.setQueriesData(['collections'], (oldData: RawCollection[] | undefined) => {
        if (!oldData) {
            return oldData;
        }

        const optimisticItemId = getOptimisticId();

        return [
            {
                id: optimisticCollectionId,
                slug: optimisticCollectionId,
                name: collection.name,
                ownerType: collection.ownerType,
                totalGigs: resourceType === 'GIG' ? 1 : 0,
                totalSellers: resourceType === 'SELLER' ? 1 : 0,
                totalInspireDeliveries: 0,
                items: resourceType && resourceId ? [{ id: optimisticItemId, resourceId, resourceType }] : [],
            },
            ...oldData,
        ];
    });

    const rollback = () => {
        queryClient.setQueriesData(['collections'], (oldData: RawCollection[] | undefined) => {
            if (!oldData) {
                return oldData;
            }

            return oldData.filter((c) => c.id !== optimisticCollectionId);
        });
    };

    return rollback;
};
